import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',  //去掉url中的#
    routes: [
        {
            path: '/',
            component: resolve => require(['../pages/index'], resolve),
            name: 'index',
            meta: {
                title: '首页',
                keepAlive: true
            }
        },
        {
            path: '/order',
            component: resolve => require(['../pages/order'], resolve),
            name: 'order',
            meta: {
                title: '订单中心',
                keepAlive: false
            }
        },
        {
            path: '/order_mt',
            component: resolve => require(['../pages/order_mt'], resolve),
            name: 'order_mt',
            meta: {
                title: '官返订单',
                keepAlive: false
            }
        },

        {
            path: '/my',
            component: resolve => require(['../pages/my'], resolve),
            name: 'my',
            meta: {
                title: '我的'
            }
        },
        {
            path: '/service',
            component: resolve => require(['../pages/service'], resolve),
            meta: {
                title: '客服'
            }
        },
        {
            path: '/work',
            component: resolve => require(['../pages/work'], resolve),
            name: 'work',
            meta: {
                title: '商家中心'
            }
        },
        {
            path: '/works',
            component: resolve => require(['../pages/works'], resolve),
            name: 'works',
            meta: {
                title: '工作人员'
            }
        },
        {
            path: '/works_list',
            component: resolve => require(['../pages/works_list'], resolve),
            name: 'works_list',
            meta: {
                title: '商家账单'
            }
        },
        {
            path: '/workInfo',
            component: resolve => require(['../pages/workInfo'], resolve),
            name: 'workInfo',
            meta: {
                title: '花乐值对账单'
            }
        },
        {
            path: '/team',
            component: resolve => require(['../pages/team'], resolve),
            name: 'team',
            meta: {
                title: '我的楼友'
            }
        },
        {
            path: '/team_qrcode',
            component: resolve => require(['../pages/team_qrcode'], resolve),
            name: 'team_qrcode',
            meta: {
                title: '邀请楼友'
            }
        },
        {
            path: '/coupon',
            component: resolve => require(['../pages/coupon'], resolve),
            name: 'coupon',
            meta: {
                title: '购买奖励券'
            }
        },
        {
            path: '/my_coupon',
            component: resolve => require(['../pages/my_coupon'], resolve),
            name: 'my_coupon',
            meta: {
                title: '我的奖励券'
            }
        },
        {
            path: '/help',
            component: resolve => require(['../pages/help'], resolve),
            name: 'help',
            meta: {
                title: '帮助中心'
            }
        },
        {
            path: '/helpDetail',
            component: resolve => require(['../pages/helpDetail'], resolve),
            name: 'helpDetail',
            meta: {
                title: '帮助中心'
            }
        },
        {
            path: '/withdrawal_record',
            component: resolve => require(['../pages/withdrawal_record'], resolve),
            name: 'withdrawal_record',
            meta: {
                title: '提现明细'
            }
        },
        {
            path: '/withdrawal',
            component: resolve => require(['../pages/withdrawal'], resolve),
            name: 'withdrawal',
            meta: {
                title: '提现明细'
            }
        },
        {
            path: '/uploadVoucher',
            component: resolve => require(['../pages/uploadVoucher'], resolve),
            name: 'uploadVoucher',
            meta: {
                title: '上传评鉴'
            }
        },
        {
            path: '/uploadVoucherShow',
            component: resolve => require(['../pages/uploadVoucherShow'], resolve),
            name: 'uploadVoucherShow',
            meta: {
                title: '查看评鉴'
            }
        },
        {
            path: '/cooperation',
            component: resolve => require(['../pages/cooperation'], resolve),
            meta: {
                title: '商务合作'
            }
        },
        {
            path: '/cancelregistration',
            component: resolve => require(['../pages/cancelregistration'], resolve),
            name: 'cancelregistration',
            meta: {
                title: '活动详情'
            }
        },
        {
            path: '/cancelregistrations',
            component: resolve => require(['../pages/cancelregistrations'], resolve),
            name: 'cancelregistrations',
            meta: {
                title: '活动详情'
            }
        },
        {
            path: '/cancelregistration_mt',
            component: resolve => require(['../pages/cancelregistration_mt'], resolve),
            name: 'cancelregistration_mt',
            meta: {
                title: '活动详情'
            }
        },
        {
            path: '/instructions',
            component: resolve => require(['../pages/instructions'], resolve),
            meta: {
                title: '使用说明'
            }
        },
        {
            path: '/qun',
            component: resolve => require(['../pages/qun'], resolve),
            meta: {
                title: '加入群聊'
            }
        },
        {
            path: '/category',
            component: resolve => require(['../pages/category'], resolve),
            name: 'category',
            meta: {
                title: '分类'
            }
        },
        {
            path: '/getCode',
            component: resolve => require(['../pages/getCode'], resolve),
            name: 'getCode',
            meta: {
                title: '授权'
            }
        },
        {
            path: '/bindMobile',
            component: resolve => require(['../pages/bindMobile'], resolve),
            name: 'bindMobile',
            meta: {
                title: '绑定手机号'
            }
        },
        {
            path: '/login',
            component: resolve => require(['../pages/login'], resolve),
            name: 'login',
            meta: {
                title: '员工登录'
            }
        },
        {
            path: '/wxqrcode',
            component: resolve => require(['../pages/wxqrcode'], resolve),
            name: 'wxqrcode',
            meta: {
                title: '上传微信收款码'
            }
        },
        {
            path: '/dre',
            component: resolve => require(['../pages/dre'], resolve),
            name: 'dre',
            meta: {
                title: '我的饭友'
            }
        },
        {
            path: '/dre_log',
            component: resolve => require(['../pages/dre_log'], resolve),
            name: 'dre',
            meta: {
                title: '收益明细'
            }
        },
        {
            path: '/share',
            component: resolve => require(['../pages/share'], resolve),
            name: 'dre',
            meta: {
                title: '分享'
            }
        },
        {
            path: '/web',
            component: resolve => require(['../pages/web'], resolve),
            name: 'web',
            meta: {
                title: '详情'
            }
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js